import { gql } from "@apollo/client";

export const QUERY_MFA_OUTAGE_SHOPS = gql`
  query MfaOutageShops($uid: String!) {
    associations(where: { user: { authid: { _eq: $uid } } }, order_by: { bodyshop: { shopname: asc } }) {
      id
      active
      bodyshop {
        id
        shopname
        require_mfa
      }
    }
  }
`;

// Both updates are scoped to the signed-in user. If the target's policy changed,
// neither update matches, preserving the existing active association.
export const ACTIVATE_MFA_OUTAGE_SHOP = gql`
  mutation ActivateMfaOutageShop($uid: String!, $associationId: uuid!) {
    active: update_associations(
      where: { id: { _eq: $associationId }, user: { authid: { _eq: $uid } }, bodyshop: { require_mfa: { _eq: false } } }
      _set: { active: true }
    ) {
      affected_rows
    }
    inactive: update_associations(
      where: {
        id: { _neq: $associationId }
        user: {
          authid: { _eq: $uid }
          associations: {
            id: { _eq: $associationId }
            active: { _eq: true }
            bodyshop: { require_mfa: { _eq: false } }
          }
        }
      }
      _set: { active: false }
    ) {
      affected_rows
    }
  }
`;

export const isServerUnavailable = (error) =>
  error?.response?.status >= 500 || ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error?.code);

export async function getOutageShops(client, uid) {
  if (!uid) throw new Error("Missing authenticated user");
  const { data } = await client.query({
    query: QUERY_MFA_OUTAGE_SHOPS,
    variables: { uid },
    fetchPolicy: "no-cache"
  });
  return data.associations.map((association) => ({
    associationId: association.id,
    active: association.active,
    id: association.bodyshop?.id,
    name: association.bodyshop?.shopname,
    requiresMfa: association.bodyshop?.require_mfa
  }));
}
